import { IExportPlugin, PluginType } from '@/version-types';
import { ShortcutMenu } from './shortcut-menu';
import shortcutMenuState from './states/shortcut-menu-state';
import ShortcutMenuView from './views/shortcut';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 3,
    name: 'shortcut-menu',
    render() {
        return <ShortcutMenuView />;
    },
    createInstance({ identity }) {
        return [{ key: 'ShortcutMenu', value: new ShortcutMenu(identity) }];
    },
    createState() {
        return [shortcutMenuState];
    },
};

export default exportPlugin;
